import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoCircleIcon } from 'foundations-assets/icons/components/InfoCircleIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IncludedSeats = ({
  // includedTotalSeats,
  includedSalesSeats = 0,
  includedServiceSeats = 0,
  includedCommerceSeats = 0,
  includedCoreSeats = 0
}) => {
  // "Mixed" is defined as Core + at least one specialty seat type. Plans with
  // only specialty seats (e.g. Sales + Service, no Core) are not valid plan
  // configurations in the current product model, so we don't need to handle them.
  const hasMixedSeats = includedCoreSeats > 0 && (includedSalesSeats > 0 || includedServiceSeats > 0 || includedCommerceSeats > 0);
  const includedTotalSeats = includedCoreSeats + includedSalesSeats + includedServiceSeats + includedCommerceSeats;
  if (hasMixedSeats) {
    const seatItems = [{
      count: includedCoreSeats,
      message: 'seatsComponents.includedSeats.tooltipItem.core'
    }, {
      count: includedSalesSeats,
      message: 'seatsComponents.includedSeats.tooltipItem.sales'
    }, {
      count: includedServiceSeats,
      message: 'seatsComponents.includedSeats.tooltipItem.service'
    }, {
      count: includedCommerceSeats,
      message: 'seatsComponents.includedSeats.tooltipItem.commerce'
    }].filter(({
      count
    }) => count > 0).sort((a, b) => b.count - a.count);
    const tooltipTitle = /*#__PURE__*/_jsx(List, {
      styled: true,
      children: seatItems.map(({
        count,
        message
      }) => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: message,
          options: {
            count
          }
        })
      }, message))
    });
    return /*#__PURE__*/_jsxs(Flex, {
      as: "span",
      display: "inline-flex",
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "seatsComponents.includedSeats.mixed",
        options: {
          count: includedTotalSeats
        }
      }), /*#__PURE__*/_jsx(Tooltip, {
        use: "longform",
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "seatsComponents.includedSeats.tooltipHeading"
        }),
        title: tooltipTitle,
        placement: "top",
        children: /*#__PURE__*/_jsx("span", {
          role: "img",
          "aria-label": I18n.text('seatsComponents.includedSeats.iconAriaLabel'),
          children: /*#__PURE__*/_jsx(InfoCircleIcon, {})
        })
      })]
    });
  }
  if (includedSalesSeats > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.sales",
      options: {
        count: includedSalesSeats
      }
    });
  }
  if (includedServiceSeats > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.service",
      options: {
        count: includedServiceSeats
      }
    });
  }
  if (includedCoreSeats > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.core",
      options: {
        count: includedCoreSeats
      }
    });
  }
  return null;
};